<script>
import Dept from "@/CommonDP/VForm/dept/index.vue";
import orgService from "@/CommonDP/service/org-service";
export default {
  extends: Dept,
  inheritAttrs: false,
  data() {
    return { updateKey: 0, deptMap: {}};
  },
  computed: {
    formatDeptList() {
      const {
        singleDept: { deptId, deptName }
      } = this;
      return deptId ? [{ deptId, deptName }] : [];
    },
    myRules() {
      return [
        ...this.rules,
        {
          required: this.options.required,
          message: this.options.requiredHint
        }
      ];
    },
    loading() {
      const { fieldModel, singleDept: { deptId }} = this;
      return (fieldModel || '') !== (deptId || '');
    },
    singleDept() {
      const { updateKey, fieldModel, deptMap } = this;
      // updateKey 只是为了维持计算属性更新
      updateKey;
      return deptMap[fieldModel] || {};
    }
  },
  watch: {
    fieldModel: {
      immediate: true,
      handler: "handleDeptIdChanged"
    },
    singleDept: {
      immediate: true,
      handler: "onSingDeptChange"
    }
  },
  methods: {
    formatDeptToValue(value) {
      if (Array.isArray(value)) {
        return value[0]?.deptId;
      } else {
        return value;
      }
    },
    clearAll() {
      this.preventDesign();
      this.updateValue([]);
      this.emitValidate();
    },
    async removeUser() {
      this.clearAll();
    },
    async onFieldModel(value) {
      await this.handleDeptIdChanged(value);
    },
    onSingDeptChange() {
      const { singleDept } = this;
      this.deptIds = singleDept.deptId;
      this.deptNames = singleDept.deptName;
      this.fullNames = singleDept.fullDeptName;
    },
    async updateValue(data) {
      const value = this.formatDeptToValue(data);
      this.fieldModel = value;
    },
    async handleDeptIdChanged(newDeptId) {
      const { deptMap } = this;
      this.forceSetValue(newDeptId);
      if (newDeptId && !deptMap[newDeptId]) {
        const { data } = await orgService.orgInfo(newDeptId);
        this.$set(deptMap, newDeptId, data);
      }
      this.updateKey++;
    },
    withUpdate() {}
  }
};
</script>
